import { render, staticRenderFns } from "./balanceCard.vue?vue&type=template&id=2dd43d3b&scoped=true&"
import script from "./balanceCard.vue?vue&type=script&lang=js&"
export * from "./balanceCard.vue?vue&type=script&lang=js&"
import style0 from "./balanceCard.vue?vue&type=style&index=0&id=2dd43d3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd43d3b",
  null
  
)

export default component.exports